import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class MlroViewHttpService {

  serverUrl = environment.serverUrl;

  constructor( public httpClient: HttpClient) { }

  getCustomerCases(frequencyParam: string) {
    return this.httpClient.get(this.serverUrl + '/transaction/mro_view?req_type=cases_by_customer&freq_type=' + frequencyParam);
  }

  getCustomerStatus(frequencyParam: string) {
    return this.httpClient.get(this.serverUrl + '/transaction/mro_view?req_type=cases_by_status&freq_type=' + frequencyParam);
  }

  getCustomerRisk(frequencyParam: string) {
    return this.httpClient.get(this.serverUrl + '/transaction/mro_view?req_type=risk_breakdown&freq_type=' + frequencyParam);
  }
}
